import {DIALOG_TYPE, LayoutConfig} from '@spartacus/storefront';
import {SupportFormComponent} from '@app/shared/support-form/iframe/support-form.component';
import {
  WriteReviewDialogComponent
} from '@app/product/details/review/write-review/write-review-dialog/write-review-dialog.component';
import {
  CcRestrictedCountryIframeComponent
} from '@app/shared/select-type/cc-restricted-country-iframe/cc-restricted-country-iframe.component';
import {LeadFormComponent} from '@app/product/cta-form/lead-form/lead-form.component';
import {MobileSearchNavBarComponent} from '@app/search/results/search-navigation-bar/mobile-facet-filter/mobile-search-nav-bar.component';
import {CyberSourceThreedsDialogComponent} from '@app/payment/components/cybersource/cyber-source-threeds-dialog/cyber-source-threeds-dialog.component';

export const dialogLayoutConfig: LayoutConfig = {
  launch: {
    SUPPORT_FORM: {
      inlineRoot: true,
      component: SupportFormComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    WRITE_REVIEW: {
      inlineRoot: true,
      component: WriteReviewDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CC_RESTRICTED: {
      inlineRoot: true,
      component: CcRestrictedCountryIframeComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    LEAD_FORM: {
      inlineRoot: true,
      component: LeadFormComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    SEARCH_NAVBAR: {
      inlineRoot: true,
      component: MobileSearchNavBarComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    CYBERSOURCE_3DS_IFRAME: {
      inlineRoot: true,
      component: CyberSourceThreedsDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    }
  },
};
